import { AlertTriangle } from 'lucide-react';
import { Button } from '../../../../components/ui/button';

interface PAMMErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
}

export default function PAMMErrorState({
  title = 'Something went wrong',
  message = 'An error occurred while loading data. Please try again.',
  onRetry,
  className = '',
}: PAMMErrorStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center py-16 text-center px-4 ${className}`}
    >
      <div className="mb-4 p-5 bg-red-50 rounded-2xl">
        <AlertTriangle className="h-12 w-12 text-red-500" />
      </div>
      <h3 className="text-base font-semibold text-foreground mb-1.5">
        {title}
      </h3>
      <p className="text-sm text-muted-foreground max-w-sm mb-5">{message}</p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry} size="sm">
          Try Again
        </Button>
      )}
    </div>
  );
}
